<template>
  <transition name="fade" :duration="{ enter: 300, leave: 100 }" appear>
    <portal to="bottomPage">
      <div v-if="showModal" class="overlay"  >
        <div ref="scroller" :id="identifier" class="scroller fluid-scroll">
          <div class="container-fluid m-0 p-0 pb-3" style="min-height: 100%" @mousedown="manualClose">
            <div class="p-0 py-4" :class="customClass">
              <div v-if="showCloseButton" class="row no-gutters">
                <div class="col text-right">
                  <a href="javascript:void(0)" class="btn btn-secondary btn-lg" @mousedown.stop="manualClose">{{ $t('mi_detail.close') }}</a>
                </div>
              </div>
            </div>
            <transition name="fade" :duration="{ enter: 300, leave: 100 }" @after-leave="afterLeave" @after-enter="afterEnter" appear>
              <div v-if="isOpen" :class="customClass" class="p-0 mb-4"  @mousedown.stop>
                <slot @close="manualClose">
                  <component v-if="slotContent" :is="slotContent.component" v-bind="slotContent.bind" @close="manualClose" />
                </slot>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </portal>
  </transition>
</template>

<script>
import Vue from 'vue';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';
import Utils from 'libs/utils';
import Navigation from 'libs/classes/navigation';
import { defaultSaveDialog } from 'libs/beforeunload';

const component = {
  props: {
    closeCallback: {
      default: null
    },
    showModal: {
      default: false
    },
    isFunctional: {
      default: false
    },
    slotContent: {
      default: null
    },
    beforeClose: {
      default: null
    },
    customClass: {
      default: 'container'
    },
    showSaveDialog: {
      default: false
    },
    showCloseButton: {
      default: true
    }
  },
  data () {
    const self = this;
    const id = Utils.getRandomID();
    return {
      identifier: id,
      navigationItem: {
        name: id,
        close: () => self.manualClose()
      },
      type: null,
      parentNode: null,
      isOpen: false
    };
  },
  mounted () {
    if (this.showModal) this.show();
    this.parentNode = this.$el.parentNode;
  },
  methods: {
    show () {
      if (this.isOpen) return;

      if (!this.isFunctional) {
        document.body.appendChild(this.$el);
        this.updateBodyScroll(true);
      }
      if (this.isFunctional && this.$refs.scroller) {
        this.updateBodyScroll(true);
      }
      const stateobj = {
        modal: this.identifier
      };
      const self = this;
      this.addNavigationItem();

      // add new
      window.history.pushState(stateobj, 'modal', window.location.href + '#' + self.identifier);
      window.addEventListener('popstate', self.handlePopState);

      this.isOpen = true;
    },
    handlePopState (event) {
      const self = this;
      if (Navigation.isTopMost(self.navigationItem)) {
        self.close();
        window.removeEventListener('popstate', this.handlePopState);
      }
    },
    addNavigationItem () {
      Navigation.addItem(this.navigationItem);
    },
    removeNavigationItem () {
      Navigation.removeItem(this.navigationItem);
    },
    updateBodyScroll (lock) {
      const self = this;
      this.$nextTick(() => {
        // const targetElement = this.$refs.scroller;
        const targetElement = document.getElementById(this.identifier);
        if (lock) {
          disableBodyScroll(targetElement);
        } else {
          enableBodyScroll(targetElement);
          clearAllBodyScrollLocks();
        }
      });
    },
    close () {
      this.removeNavigationItem();
      this.updateBodyScroll(false);
      if (!this.isFunctional) {
        this.parentNode.appendChild(this.$el);
      }
      this.isOpen = false;
    },
    async manualClose () {
      if (this.isOpen) {
        if (await this.validateBeforeClose()) {
          window.history.go(-1);
        }
      }
    },
    async validateBeforeClose() {
      if (!this.beforeClose) return true;

      if (!this.showSaveDialog) return await this.beforeClose();
      
      const self = this;
      let result = new Promise((resolve, reject) => {
        const saveSuccess = defaultSaveDialog(self, self.beforeClose, () => true);
        saveSuccess((saved) => {
          if (saved) resolve(true);
        });
      });

      return result;
    },
    afterLeave () {
      if (this.closeCallback) this.closeCallback();
      if (this.isFunctional) {
        // destroy the vue listeners, etc
        this.$destroy();
        // remove the element from the DOM
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    afterEnter () {
      this.$emit('after-enter');
    }
  },
  watch: {
    showModal: {
      handler: function (newvalue, oldvalue) {
        if (newvalue === oldvalue) return;
        this.$nextTick(() => {
          if (newvalue && !oldvalue) {
            this.show();
          } else if (!newvalue && oldvalue) {
            this.manualClose();
          }
        });
      },
      immediate: true
    }
  }
};
export default component;

export const GetModal = (container, closeCallback, slotContent) => {
  const componentClass = Vue.extend(component);
  const instance = new componentClass({
    propsData: {
      closeCallback: closeCallback,
      isFunctional: true,
      showModal: true,
      slotContent: slotContent
    }
  });
  instance.$mount();
  container.appendChild(instance.$el);
};
</script>

<style lang="scss" scoped>
.overlay {
  -webkit-tap-highlight-color: transparent;
  background: rgba(0, 0, 0, .7);
  bottom: 0;
  left: 0;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 500;

  .scroller {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}

@media (min-width: 768px) {
    .container-small {
        width: 300px;
    }
    .container-large {
        width: 970px;
    } 
} 
@media (min-width: 992px) {
    .container-small {
        width: 500px;
    }
    .container-large {
        width: 1170px;
    } 
} 
@media (min-width: 1200px) {
    .container-small {
        width: 700px;
    }
    .container-large {
        width: 1500px;
    } 
}

.container-small, .container-large {
    max-width: 100%;
}
.max-width-90{
  max-width: 90%;
}
</style>
